import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=2d8f1e3a&"
import script from "./Interview.vue?vue&type=script&lang=ts&"
export * from "./Interview.vue?vue&type=script&lang=ts&"
import style0 from "./Interview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports